import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[numberOnly]',
  standalone: true
})
export class NumberOnlyDirective {
  private regex = /[^0-9]/g;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  // sanitize on any input change (covers drag/drop, autofill, IME commits)
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const cleaned = input.value.replace(this.regex, '');
    if (cleaned !== input.value) {
      const selectionStart = input.selectionStart ?? input.value.length;
      input.value = cleaned;
      // restore caret at nearest position
      input.setSelectionRange(Math.max(0, selectionStart - 1), Math.max(0, selectionStart - 1));
      // dispatch input event so Angular formControl picks up change
      input.dispatchEvent(new Event('input'));
    }
  }

  // block invalid key presses
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  // block invalid paste
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (this.regex.test(pasted)) {
      event.preventDefault();
      // optionally insert sanitized paste
      const cleaned = pasted.replace(this.regex, '');
      const input = this.el.nativeElement;
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? start;
      const newVal = input.value.slice(0, start) + cleaned + input.value.slice(end);
      input.value = newVal;
      input.dispatchEvent(new Event('input'));
    }
  }
}
